import React from 'react';

// Intro block — lead paragraph under the hero. Presentation only.
export default function Intro({ text }) {
  return <p className="mb-10 max-w-2xl leading-relaxed text-neutral-600">{text}</p>;
}
